//
// Software Name: Orange Design System Charts
// SPDX-FileCopyrightText: Copyright (c) 2023 - 2026 Orange SA
// SPDX-License-Identifier: MIT
//
// This software is distributed under the MIT license.
//
export const DEFAULT_OUDS_COLORS_YELLOW = {
    color: [
        'var(--ouds-charts-color-sequential-accent-5-tint-100)',
        'var(--ouds-charts-color-sequential-accent-5-tint-200)',
        'var(--ouds-charts-color-sequential-accent-5-tint-300)',
        'var(--ouds-charts-color-sequential-accent-5-tint-400)',
        'var(--ouds-charts-color-sequential-accent-5-tint-500)',
        'var(--ouds-charts-color-sequential-accent-5-tint-600)',
        'var(--ouds-charts-color-sequential-accent-5-tint-700)',
        'var(--ouds-charts-color-sequential-accent-5-tint-800)',
        'var(--ouds-charts-color-sequential-accent-5-tint-900)',
    ],
};
